import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import {
  fadeUpFar,
  fadeUpFarther,
  scaleUp,
  staggerContainer,
  staggerItem,
  viewportOnce,
} from '../hooks/useAnimations'
import OverviewMap from '../components/OverviewMap'
import notesIndex from '../generated/notes-index.json'
import states from '../generated/states.json'
import './Home.css'

export default function Home() {
  return (
    <main className="home">
      <section className="hero">
        <div className="hero-inner">
          <motion.h1
            className="hero-title"
            variants={fadeUpFarther}
            initial="hidden"
            animate="visible"
          >
            US State Route Markers
          </motion.h1>

          <motion.p className="section-intro" variants={fadeUpFar} initial="hidden" animate="visible">
            A redesign of state route markers for all fifty states, the District of Columbia, and
            Puerto Rico—restoring historical character while meeting modern legibility standards.
          </motion.p>

          <motion.p className="section-intro" variants={fadeUpFar} initial="hidden" animate="visible">
            Each marker answers two questions at once: which road am I on, and which state am I in?
            The series treats these signs as cultural artifacts—restoration rather than replacement.
          </motion.p>
        </div>
      </section>

      <section className="map-section">
        <div className="section-inner">
          <OverviewMap />
        </div>
      </section>

      <section className="notes-section">
        <div className="section-inner">
          <motion.h2
            className="cta-title"
            variants={fadeUpFar}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
          >
            Project Notes
          </motion.h2>

          <motion.ul
            className="notes-links"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
          >
            {notesIndex.map((note) => (
              <motion.li key={note.slug} variants={staggerItem}>
                <a href={note.href} className="cta-link">
                  ↗ {note.title}
                </a>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </section>

      <section className="states-section">
        <div className="section-inner">
          <motion.h2
            className="cta-title"
            variants={fadeUpFar}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
          >
            All States
          </motion.h2>

          <motion.div
            className="states-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
          >
            {states.map((state) => (
              <motion.div key={state.slug} variants={scaleUp}>
                <Link to={`/states/${state.slug}`} className="state-card">
                  <div className="state-card-image media-zoom">
                    <img src={state.image} alt="" loading="lazy" />
                    <div className="state-card-badge">
                      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                          d="M7 17L17 7M17 7H9M17 7V15"
                          stroke="#000"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="state-card-body">
                    <span className="state-card-name">{state.name}</span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </main>
  )
}
